export const ResourceKind = {
    string: 'string',
    richtext: 'richtext',
    googledoc: 'googledoc',
}
